import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: '[app-key-values-row]',
    templateUrl: './key-values-row.component.html',
    styleUrls: ['./key-values-row.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgbPopover],
})
export class KeyValuesRowComponent {
    @Input() label = '';
    @Input() values: string[] | undefined;
    @Input() allowEdit = false;
    @Input() toolTip: string | undefined;
    @Output() emitUpdate = new EventEmitter<void>();
    updateValue(): void {
        this.emitUpdate.emit();
    }
}
